import * as React from 'react';
import { TextInput } from "soprasteria-ui-library";
import { IPatient } from '../../../models/IPatient';
import { formatAddress } from "../../../helpers/AddressHelper";
import { formatPersonalSecurityNumberAndOrganisationNumber } from "../../../helpers/PersonalSecurityNumberAndOrganisationNumberHelper";

interface IPatientInformationSection {
    patient: IPatient;
}

export const PatientInformationSection: React.FunctionComponent<IPatientInformationSection> = ({ patient }) => {

    return (
        <div className="row readonly-less-margin">
            <h5 className="col-12">Patientinformation</h5>
            <div className="col-12">
                <TextInput name="nameReadonly" label="Namn" defaultValue={patient.name} labelCol={2} inputCol={10} inlineLabel readonly />
            </div>
            <div className="col-6">
                <TextInput name="pnrReadonly" label="Personnummer" defaultValue={formatPersonalSecurityNumberAndOrganisationNumber(patient.personalSecurityNumber)} inlineLabel readonly />
            </div>
            <div className="col-6">
                <TextInput name="addressReadonly" label="Adress" defaultValue={formatAddress(patient.address)} inlineLabel readonly />
            </div>
            <div className="col-6">
                <TextInput name="patientPhoneNumberReadonly" label="Telefon" defaultValue={patient.phoneNumber ?? "Saknas"} inlineLabel readonly />
            </div>
            <div className="col-6">
                <TextInput name="patientEmailReadonly" label="E-post" defaultValue={patient.email ?? "Saknas"} inlineLabel readonly />
            </div>
        </div>
    )
}